import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@mui/styles';

// import ReactDOM from 'react-dom/client';
// import './index.css';
import App from '../App';
import CardX from '../component/card.js'
import PlaceX from '../component/place.js';

import reportWebVitals from '../reportWebVitals';
import { styled } from '@mui/material/styles';
import { Grid, Box, Paper, Button, Card, Container, Typography, CardMedia, Fab, Divider, Link } from '@mui/material';
import ScrollIntoView from 'react-scroll-into-view'

// import { BrowserRouter as Router, Routes, Route }
// 	from 'react-router-dom';
// import Map_page from './map.js';


import Bigmap from '../images/Artboard 2.jpg';
import Bigmap1 from '../images/Artboard 1.jpg';
import th from '../images/language-02.png';
import en from '../images/language-01.png';
import head from '../images/Text First Image-06.png';

import map01_02000 from '../images/01_iconsiam_2000.jpg'
import map01_04000 from '../images/01_iconsiam_4000.jpg'
import map01_08000 from '../images/01_iconsiam_8000.jpg'
import map01_big from '../images/01_iconsiam_000.png'
import map01 from '../images/01_iconsiam.jpg'
import map02_02000 from '../images/02_Democracy Monument_2000.jpg'
import map02_04000 from '../images/02_Democracy Monument_4000.jpg'
import map02_08000 from '../images/02_Democracy Monument_8000.jpg'
import map02_big from '../images/02_Democracy Monument_000.png'
import map02 from '../images/02_Democracy Monument.jpg'
import map03_02000 from '../images/03_Sanam Luang_2000.jpg'
import map03_04000 from '../images/03_Sanam Luang_4000.jpg'
import map03_08000 from '../images/03_Sanam Luang_8000.jpg'
import map03_big from '../images/03_Sanam Luang_000.png'
import map03 from '../images/03_Sanam Luang.jpg'
import map04_02000 from '../images/04_Rama 9 Memorial Park_2000.jpg'
import map04_04000 from '../images/04_Rama 9 Memorial Park_4000.jpg'
import map04_08000 from '../images/04_Rama 9 Memorial Park_8000.jpg'
import map04_big from '../images/04_Rama 9 Memorial Park_000.png'
import map04 from '../images/04_Rama 9 Memorial Park.jpg'
import map05_02000 from '../images/05_Romaneenart Park_2000.jpg'
import map05_04000 from '../images/05_Romaneenart Park_4000.jpg'
import map05_08000 from '../images/05_Romaneenart Park_8000.jpg'
import map05_big from '../images/05_Romaneenart Park_000.png'
import map05 from '../images/05_Romaneenart Park.jpg'
import map06_02000 from '../images/06_Wat Arun Ratchawaram_2000.jpg'
import map06_04000 from '../images/06_Wat Arun Ratchawaram_4000.jpg'
import map06_08000 from '../images/06_Wat Arun Ratchawaram_8000.jpg'
import map06_big from '../images/06_Wat Arun Ratchawaram_000.png'
import map06 from '../images/06_Wat Arun Ratchawaram.jpg'
import map07_02000 from '../images/07_Tha Phra MRT Station_2000.jpg'
import map07_04000 from '../images/07_Tha Phra MRT Station_4000.jpg'
import map07_08000 from '../images/07_Tha Phra MRT Station_8000.jpg'
import map07_big from '../images/07_Tha Phra MRT Station_000.png'
import map07 from '../images/07_Tha Phra MRT Station.jpg'
import map08_02000 from '../images/08_Khlong Chak Phra_2000.jpg'
import map08_04000 from '../images/08_Khlong Chak Phra_4000.jpg'
import map08_08000 from '../images/08_Khlong Chak Phra_8000.jpg'
import map08_big from '../images/08_Khlong Chak Phra_000.png'
import map08 from '../images/08_Khlong Chak Phra.jpg'
import map09_02000 from '../images/09_Rama 8 Bridge_2000.jpg'
import map09_04000 from '../images/09_Rama 8 Bridge_4000.jpg'
import map09_08000 from '../images/09_Rama 8 Bridge_8000.jpg'
import map09_big from '../images/09_Rama 8 Bridge_000.png'
import map09 from '../images/09_Rama 8 Bridge.jpg'
import map10_02000 from '../images/10_Wongwian Yai_2000.jpg'
import map10_04000 from '../images/10_Wongwian Yai_4000.jpg'
import map10_08000 from '../images/10_Wongwian Yai_8000.jpg'
import map10_big from '../images/10_Wongwian Yai_000.png'
import map10 from '../images/10_Wongwian Yai.jpg'

import d_map01_02000 from '../images/download/01_iconsiam_2000.jpg'
import d_map01_04000 from '../images/download/01_iconsiam_4000.jpg'
import d_map01_08000 from '../images/download/01_iconsiam_8000.jpg'
import d_map02_02000 from '../images/download/02_Democracy Monument_2000.jpg'
import d_map02_04000 from '../images/download/02_Democracy Monument_4000.jpg'
import d_map02_08000 from '../images/download/02_Democracy Monument_8000.jpg'
import d_map03_02000 from '../images/download/03_Sanam Luang_2000.jpg'
import d_map03_04000 from '../images/download/03_Sanam Luang_4000.jpg'
import d_map03_08000 from '../images/download/03_Sanam Luang_8000.jpg'
import d_map04_02000 from '../images/download/04_Rama 9 Memorial Park_2000.jpg'
import d_map04_04000 from '../images/download/04_Rama 9 Memorial Park_4000.jpg'
import d_map04_08000 from '../images/download/04_Rama 9 Memorial Park_8000.jpg'
import d_map05_02000 from '../images/download/05_Romaneenart Park_2000.jpg'
import d_map05_04000 from '../images/download/05_Romaneenart Park_4000.jpg'
import d_map05_08000 from '../images/download/05_Romaneenart Park_8000.jpg'
import d_map06_02000 from '../images/download/06_Wat Arun Ratchawaram_2000.jpg'
import d_map06_04000 from '../images/download/06_Wat Arun Ratchawaram_4000.jpg'
import d_map06_08000 from '../images/download/06_Wat Arun Ratchawaram_8000.jpg'
import d_map07_02000 from '../images/download/07_Tha Phra MRT Station_2000.jpg'
import d_map07_04000 from '../images/download/07_Tha Phra MRT Station_4000.jpg'
import d_map07_08000 from '../images/download/07_Tha Phra MRT Station_8000.jpg'
import d_map08_02000 from '../images/download/08_Khlong Chak Phra_2000.jpg'
import d_map08_04000 from '../images/download/08_Khlong Chak Phra_4000.jpg'
import d_map08_08000 from '../images/download/08_Khlong Chak Phra_8000.jpg'
import d_map09_02000 from '../images/download/09_Rama 8 Bridge_2000.jpg'
import d_map09_04000 from '../images/download/09_Rama 8 Bridge_4000.jpg'
import d_map09_08000 from '../images/download/09_Rama 8 Bridge_8000.jpg'
import d_map10_02000 from '../images/download/10_Wongwian Yai_2000.jpg'
import d_map10_04000 from '../images/download/10_Wongwian Yai_4000.jpg'
import d_map10_08000 from '../images/download/10_Wongwian Yai_8000.jpg'

import top from '../svg/top.svg'
import mail from '../svg/mail.svg'
import phone from '../svg/phone.svg'
import fb from '../svg/fb.svg'
import ig from '../svg/ig.svg'
import lin from '../svg/in.svg'
import line from '../svg/line.svg'
import tt from '../svg/tt.svg'
import x from '../svg/x.svg'
import yt from '../svg/yt.svg'
import bkk from '../svg/bkk.svg';


const Home = () => {

  const gold = '#C89F65';
  const selected = '#4E4646';

  const [lang, setLang] = useState(1);

  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const onChangeLang = (i) => {
    setLang(i);
  };

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', handleWindowResize);
  }, []);


  return (
    <div>
      <ScrollIntoView selector="#top">
        <Fab size='large' style={{
          margin: 0,
          left: windowSize[0] - 100,
          top: windowHeight - 100,
          position: 'fixed',
        }}>
          <img height='36px' src={top} />
        </Fab>
      </ScrollIntoView>
      <Fab size='small' style={{
        margin: 0,
        left: windowSize[0] - 92,
        top: windowHeight - 150,
        position: 'fixed',
      }} onClick={() => onChangeLang(1)}>
        <img height='36px' src={en} />
      </Fab>
      <Fab size='small' style={{
        margin: 0,
        left: windowSize[0] - 92,
        top: windowHeight - 200,
        position: 'fixed',
      }} onClick={() => onChangeLang(0)}>
        <img height='36px' src={th} />
      </Fab>
      <Grid sx={12}>
        <Box sx={{ position: 'relative' }} width={'100%'} id='top'>

          <CardMedia
            component="img"
            width={windowSize[0]}
            height={windowHeight}
            src={Bigmap1}
            sx={{
              width: '100%',
              maxHeight: '100%',
              objectFit: "cover",
              objectPosition: "50% 50%",
            }}

          // style={{
          //   media: {
          //     height: 0,
          //     paddingTop: '56.25%', // 16:9,
          //     marginTop: '30'
          //   }
          // }}
          />

          {/* <img
            // component="img"
            style={{align:'left'}}
            width={windowSize[0]}
            height={windowHeight}
            src={Bigmap}
          /> */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: windowHeight / 2,
              width: '100%',
              background: 'linear-gradient(to top, rgba(0,0,0,0), rgba(0,0,0,0.9))',
              color: 'white',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              height: windowHeight / 2,
              width: '100%',
              background: 'linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.9))',
              color: 'white',
            }}
          />

          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: windowSize[0] * 0.09,
              minHeight: 0,
              // width: '100%',
              color: 'white',
              height: windowHeight * 0.8
            }}
          >
            <Grid Container padding={2}>
              {/* <Typography align='left' color='#FFF' variant="h1">
                FIRST <br />
                IMAGE
              </Typography> */}
              {/* <Typography align='left' color='#FFF' variant="body1">input some messages to explain it</Typography> */}
              <Grid sx={12}>
                <img src={head} style={{ opacity: 0.7, width: 450, maxWidth: windowSize[0] * 0.8, objectFit: 'contain' }} />
              </Grid>

              <Grid sx={12} padding={4}>
                <Button href={'/map'} target='_blank' variant="contained" sx={{
                  borderRadius: 28,
                  transition: "transform 0.15s ease-in-out",
                  "&:hover": {
                    transform: "scale3d(1.15, 1.15, 1.0)",
                    backgroundColor: selected
                  },
                }} style={{
                  backgroundColor: "#FFF",
                  width: '200px',
                  height: '50px',
                  minWidth: '60px',
                  minHeight: '30px',
                  "&:hover": {
                    backgroundColor: selected
                  },
                }}
                // onClick={handleMap()}
                >
                  <Typography align='center' color={gold} variant="h5">{lang === 0 ? 'แผนที่' : lang === 1 ? 'GO TO MAP' : ''}</Typography>
                </Button>
              </Grid>


            </Grid>

          </Box>
        </Box>
      </Grid>

      <Grid sx={12}>
        <Box sx={{ position: 'relative' }} width={'100%'} id='top'>
          <CardMedia
            component="img"
            width={windowSize[0]}
            // height={'1000px'}
            image={Bigmap1}
            left={'0px'}
            top={'0px'}
            sx={{ height: { md: '1000px', xs: '550px' } }}
          />
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: '100%',
              background: 'rgba(0,0,0,0.9)',
              color: 'white',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: '8.125%',
              right: '8.125%',
              // left: windowSize[0] * 0.09,
              // width: '100%',
              // color: 'white',
              // height: windowHeigh * 0.35
            }}>
            <Grid container>
              <Grid item xs={12}>
                <Box height={'50px'} />
              </Grid>

              <Grid container xs={12} spacing={'3%'}>
                <Grid item xs={8}>
                  <img style={{ height: { md: 200, sm: 100 }, maxHeight: 200, maxWidth: windowSize[0] * 0.5 }} src={bkk} align='left' />
                  {/* <Typography align='center' color={gold} variant="h1">แลนด์มาร์ค</Typography> */}
                </Grid>

                <Grid item xs={4}>
                  <ScrollIntoView selector="#r02">
                    <CardX t2='อนุสาวรีย์ประชาธิปไตย' t1='Democracy Monument' i={map02} l={lang}></CardX>
                  </ScrollIntoView>
                </Grid>
              </Grid>

              <Grid container xs={12}>
                <Box height={20} />
              </Grid>

              <Grid container xs={12} spacing={'3%'}>
                <Grid item xs={4}>
                  <ScrollIntoView selector="#r03">
                    <CardX t2='สนามหลวง' t1='Sanam Luang' i={map03} l={lang}></CardX>
                  </ScrollIntoView>
                </Grid>

                <Grid item xs={4}>
                  <ScrollIntoView selector="#r04">
                    <CardX t2='อุทยานเฉลิมพระเกียรติฯ ร.๙' t1=' King Rama IX Memorial Park' i={map04} l={lang}></CardX>
                  </ScrollIntoView>
                </Grid>

                <Grid item xs={4}>
                  <ScrollIntoView selector="#r05">
                    <CardX t2='สวนรมมณีนาถ' t1='Rommaninat Park' i={map05} l={lang}></CardX>
                  </ScrollIntoView>
                </Grid>
              </Grid>

              <Grid container xs={12}>
                <Box height={20} />
              </Grid>

              <Grid container xs={12} spacing={'3%'}>
                <Grid item xs={4}>
                  <ScrollIntoView selector="#r09">
                    <CardX t2='สะพานพระราม ๘' t1='Rama VIII Bridge' i={map09} l={lang}></CardX>
                  </ScrollIntoView>
                </Grid>

                <Grid item xs={4}>
                  <ScrollIntoView selector="#r08">
                    <CardX t2='คลองชักพระ' t1='Khlong Chak Phra' i={map08} l={lang}></CardX>
                  </ScrollIntoView>
                </Grid>

                <Grid item xs={4}>
                  <ScrollIntoView selector="#r06">
                    <CardX t2='วัดอรุณราชวราราม' t1='Wat Arun Ratchawararam Ratchawaramahawihan' i={map06} l={lang}></CardX>
                  </ScrollIntoView>
                </Grid>
              </Grid>

              <Grid container xs={12}>
                <Box height={20} />
              </Grid>

              <Grid container xs={12} spacing={'3%'}>
                <Grid item xs={4}>
                  <ScrollIntoView selector="#r07">
                    <CardX t2='สถานีท่าพระ' t1='Tha Phra Station' i={map07} l={lang}></CardX>
                  </ScrollIntoView>
                </Grid>

                <Grid item xs={4}>
                  <ScrollIntoView selector="#r01">
                    <CardX t2='ไอคอนสยาม' t1='ICONSIAM' i={map01} l={lang}></CardX>
                  </ScrollIntoView>
                </Grid>

                <Grid item xs={4}>
                  <ScrollIntoView selector="#r10">
                    <CardX t2='วงเวียนใหญ่' t1='Wongwian Yai' i={map10} l={lang}></CardX>
                  </ScrollIntoView>
                </Grid>

              </Grid>

              <Grid item xs={12}>
                <Box height={'50px'} />
              </Grid>

            </Grid>
          </Box>
        </Box>
      </Grid>



      <Box sx={{
        height: '100%',
        bgcolor: 'black',
        // opacity: 0.9,
        backgroundImage: { map01_02000 }
      }}>

      </Box>

      <Box id='r02'>
        <PlaceX id='#02' windowSize={[windowSize[0], windowHeight]} i0={map02_big} i2={map02_02000} i4={map02_04000} i8={map02_08000} di2={d_map02_02000} di4={d_map02_04000} di8={d_map02_08000} t2='อนุสาวรีย์ประชาธิปไตย' t1='Democracy Monument' l={lang}
          t3='The Democracy Monument was built in the reign of King Rama VIII to commemorate the transition from an absolute monarchy to a constitutional monarchy. The Monument was designed by the Fine Arts Department, emphasising architectural styles that reflect the significance of the governmental transition. The Monument is erected in the middle of a traffic roundabout where Ratchadamnoen Avenue meets Dinso Road. In addition, it marks the kilometre zero point from Bangkok to another destination.
          With the high-resolution capabilities of satellites, objects sized 50 by 50 centimetres can be clearly observed. These include various architectural structures, the circular base of the monument, all four pillars, and even moving objects such as cars.
          '
          t4='“อนุสาวรีย์ประชาธิปไตย” ถูกสร้างขึ้นในสมัยรัชกาลที่ 8 เพื่อเป็นที่ระลึกในการเปลี่ยนแปลงการปกครองจาก “ระบบสมบูรณาญาสิทธิราชย์” มาเป็น “ระบอบประชาธิปไตย” 
          กรมศิลปากรเป็นผู้ออกแบบโดยเน้นรูปแบบสถาปัตยกรรมให้แสดงออกถึงความหมายของการเปลี่ยนแปลงการปกครอง เป็นอนุสาวรีย์ที่ตั้งอยู่กึ่งกลางวงเวียนระหว่าง ถนนนราชดำเนินกลางกับถนนดินสอ แขวงบวรนิเวศ เขตพระนคร และยังเป็นหลักกิโลเมตรที่ศูนย์ ซึ่งใช้อ้างอิงในการวัดระยะทางจากกรุงเทพมหานครไปยังสถานที่ต่างๆ ด้วยศักยภาพของดาวเทียมรายละเอียดสูง 50 เซนติเมตรจึงสามารถมองเห็นวัตถุที่มีขนาด 50*50 เซนติเมตรได้อย่างชัดเจน ทั้งสิ่งปลูกสร้างเป็นรูปทรงต่างๆ ฐานของอนุสาวรีย์ที่เป็นทรงกลม เสาทั้ง 4 ต้น จากมุมสูง  รวมถึงสิ่งที่กำลังเคลื่อนไหวอย่างเช่นรถยนต์
          '
        />
      </Box>

      <Box id='r03'>
        <PlaceX id='r03' windowSize={[windowSize[0], windowHeight]} i0={map03_big} i2={map03_02000} i4={map03_04000} i8={map03_08000} di2={d_map03_02000} di4={d_map03_04000} di8={d_map03_08000} t2='สนามหลวง' t1='Sanam Luang' l={lang}
          t3='Sanam Luang was formerly called ‘Thung Phra Mane’. It is one of the important archaeological sites of the nation, covering 74.16 Rai (11.71 Hectares). Sanam Luang has undergone considerable changes but the opening green field is still remaining for the important activities. From this THEOS-2 image, the tamarind trees around the field can be observed. The Wat Mahathat Yuwarajarangsarit Rajaworamahavihara (Wat Mahathat), which is the first class royal temple, and the Supreme Court complex building laid out in 3 V-sections are placed on the left and right of the imagery respectively. 
          The capability of satellites enables the observation of lined up cars. On the left side, along the Chao Phraya River, boats sailing in various directions and their waves can be seen from the imagery.The benefits of satellites can be utilized for efficient urban planning and management.
          '
          t4='“สนามหลวง” เดิมชื่อว่า “ทุ่งพระเมรุ”  สนามหลวงในปัจจุบันมีการเปลี่ยนแปลงไปค่อนข้างมาก แต่ยังคงไว้ซึ่งลานหญ้าโล่งเพื่อประกอบกิจกรรมต่างๆที่มีความสำคัญในระดับประเทศ สนามหลวงเป็นโบราณสถานสำคัญของชาติ มีเนื้อที่ 74 ไร่ 63 ตารางวาภาพจากดาวเทียม THEOS-2 ซึ่งเป็นดาวเทียมรายละเอียดสูงมาก สามารถมองเห็นบริเวณโดยรอบซึ่งจะมีต้นไม้ปลูกไว้ (มะขาม) ทางด้านซ้ายที่ปรากฎในภาพคือ วัดมหาธาตุยุวราชรังสฤษฎิ์ราชวรมหาวิหาร พระอารามหลวงชั้นเอก ส่วนด้านขวาคือ อาคารศาลฎีกา ซึ่งประกอบด้วยอาคารรูปตัววี 3 หลัง ศักยภาพของดาวเทียมทำให้เห็นถึงรถยนต์ที่จอดกันเรียงราย ด้านซ้ายบริเวณแม่น้ำเจ้าพระยามองเห็นเรือที่กำลังเล่นไปในทิศทางต่างๆและเห็นคลื่นที่เกิดจากการเคลื่อนที่ของเรือ โดยประโยชน์ของดาวเทียมสามารถนำไปบริหารจัดการด้านการวางผังเมืองที่ดีได้ 
          '
        />
      </Box>

      <Box id='r04'>
        <PlaceX id='r04' windowSize={[windowSize[0], windowHeight]} i0={map04_big} i2={map04_02000} i4={map04_04000} i8={map04_08000} di2={d_map04_02000} di4={d_map04_04000} di8={d_map04_08000} t2='อุทยานเฉลิมพระเกียรติฯ รัชกาลที่ ๙' t1='King Rama IX Memorial Park' l={lang}
          t3='The ‘King Rama IX Memorial Park’ was formerly known as ‘Nang Loeng Racecourse’. Once completed, this area will be beautifully designed in terms of architecture, featuring a public park with lush green trees that is intended to become a new lung for Bangkok. The space is designed for the public to relax, exercise, and engage in various activities together, including serving as a learning centre about forests and water. The construction design reflects sustainable water management principles, starting from the upstream through check dams, as well as the ‘Three Forests, Four Benefits’ principle. Midstream, the projects "Monkey Cheek", Chaipattana low speed surface aerator, wetland plant areas. Lastly, downstream through new theory agriculture plots, tilapia ponds, and water filtration plants.
          The satellite imagery captures changes in construction. The image reveals the construction site. Once construction is completed, a change on the site will be clearly seen from the satellite imagery.
          '
          t4='“อุทยานเฉลิมพระเกียรติฯ รัชกาลที่ 9” เดิมพื้นที่นี้คือ “สนามม้านางเลิ้ง” เมื่อสร้างเสร็จแล้วพื้นที่แห่งนี้จะมีความสวยงามทั้งด้านการออกแบบสถาปัตยกรรมอย่างลงตัว สวนสาธารณะที่มีต้นไม้เขียวขจี โดยต้องการที่จะให้พื้นที่แห่งนี้กลายเป็นปอดแห่งใหม่ของกรุงเทพมหานคร เพื่อให้ประชาชนได้ใช้พื้นที่พักผ่อนหย่อนใจ ออกกำลังกาย ทำกิจกรรมต่างๆร่วมกัน รวมถึงให้เป็นแหล่งเรียนรู้เกี่ยวกับป่าและน้ำ จากแบบการก่อสร้างได้ออกแบบอุทยานฯ แห่งนี้ให้สะท้อนหลักการบริการน้ำอย่างยั่งยืน โดยเริ่มต้นจากต้นน้ำ ผ่านฝายชะลอน้ำ และแนวคิดการปลูกป่า 3 อย่าง ประโยชน์ 4 อย่าง ส่วนกลางน้ำ ผ่านโครงการแก้มลิง กังหันน้ำชัยพัฒนา และพื้นที่พืชชุ่มน้ำ และปลายน้ำ ผ่านแปลงพื้นที่เกษตรทฤษฎีใหม่ บ่อปลานิลและการใช้พืชกรองน้ำ ภาพถ่ายจากดาวเทียมนี้จะเห็นถึงการเปลี่ยนแปลงของสิ่งปลูกสร้าง ในภาพยังไม่แล้วเสร็จ หลังจากนี้เมื่อก่อสร้างเสร็จสมบูรณ์ก็จะเห็นภาพถ่ายจากดาวเทียมในอีกรูปแบบหนึ่ง
          '
        />
      </Box>

      <Box id='r05'>
        <PlaceX id='r05' windowSize={[windowSize[0], windowHeight]} i0={map05_big} i2={map05_02000} i4={map05_04000} i8={map05_08000} di2={d_map05_02000} di4={d_map05_04000} di8={d_map05_08000} t2='สวนรมมณีนาถ' t1='Rommaninat Park' l={lang}
          t3='‘Rommaninat Park’ is a large green space in the heart of Bangkok, transformed from an old prison into a public park. It is also a registered historic site by the Fine Arts Department. Various large and small trees, many species of flowers, exercise equipment, sports courts, basketball courts, a skate park, and a playground can be found in the Park. The surrounding area is surrounded by residential homes, temples, and government office buildings. Next to the park is ‘Wat Suthat Thepwararam Rajaworamahavihara’, commonly known as ‘Wat Suthat’, a first-class royal temple. Another benefit of satellite imagery is for planning and developing the green spaces of Bangkok to promote suitability and a healthy lifestyle for the residents.
          '
          t4='“สวนรมณีนาถ” เป็นพื้นที่สีเขียวขนาดใหญ่ใจกลางกรุงเทพมหานครที่ถูกดัดแปลงจากคุกเก่า กลายมาเป็นพื้นที่สวนสาธารณะและสวนสุขภาพสำหรับทุกคน อีกทั้งเป็นโบราณสถานที่ขึ้นทะเบียนโดยกรมศิลปากร ภายในสวนรมณีนาถประกอบด้วยต้นไม้ใหญ่เล็ก ดอกไม้นานาพรรณ อุปกรณ์ออกกำลังกาย ลานกีฬา สนามบาสเกตบอล ลานสเก็ต และสนามเด็กเล่น บริเวณโดยรอบรายล้อมด้วยบ้านเรือน วัดวาอาราม สถานที่ราชการ อีกหนึ่งสถานที่สำคัญในภาพที่ตั้งอยู่เคียงข้างกันคือ “วัดสุทัศนเทพวรารามราชวรมหาวิหาร” หรือที่คนนิยมเรียกว่า วัดสุทัศน์ พระอารามหลวงชั้นเอก และอีกหนึ่งประโยชน์จากภาพถ่ายดาวเทียมคือการออกแบบ- พัฒนาพื้นที่สีเขียวของกรุงเทพมหานคร เพื่อความเหมาะสมและสุขภาพชีวิตที่ดีของคนเมืองหลวง
          '
        />
      </Box>

      <Box id='r09'>
        <PlaceX id='r09' windowSize={[windowSize[0], windowHeight]} i0={map09_big} i2={map09_02000} i4={map09_04000} i8={map09_08000} di2={d_map09_02000} di4={d_map09_04000} di8={d_map09_08000} t2='สะพานพระราม ๘' t1='Rama VIII Bridge' l={lang}
          t3='‘Rama VIII Bridge’ was built to ease traffic on the Somdet Phra Pin Klao Bridge. It is the 13th bridge across the Chao Phraya River, connecting Borommaratchachonnani Road across the river near Bang Yikhan Liqours Distilery in Bang Phlat District to the end of Wisutthikasat Road near the Bank of Thailand in Phra Nakhon District. THEOS-2 satellite, a high-resolution satellite, captures objects as small as 50 x 50 centimetres, including cars moving on the road, the lush green trees, and the yellow cables running from the tower to the deck. Beneath the Rama VIII Bridge, there is also a public park for the people of Bangkok to relax and unwind. A unique feature of the Rama VIII Bridge, not found in other Bangkok bridges, is that at the top of its tall tower there is a viewing point with a lotus-like structure made of metal and glass which can be seen from the satellite image.
          '
          t4='“สะพานพระราม 8” สะพานแห่งนี้ถูกสร้างขึ้นเพื่อลดปัญหาการจราจรบนสะพานสมเด็จพระปิ่นเกล้า เป็นสะพานข้ามแม่น้ำเจ้าพระยาแห่งที่ 13 เชื่อมระหว่างถนนบรมราชชนนี ข้ามแม่น้ำเจ้าพระยาบริเวณโรงงานสุราบางยี่ขัน เขตบางพลัดกับปลายถนนวิสุทธิกษัตริย์ ใกล้กับธนาคารแห่งประเทศไทย เขตพระนคร ความคมชัดของดาวเทียม THEOS-2 ซึ่งเป็นดาวเทียมรายละเอียดสูงมาก ทำให้มองเห็นวัตถุที่มีขนาด 50 X 50 เซนติเมตรได้อย่างชัดเจน เห็นแม้กระทั่งรถยนต์ที่กำลังแล่นอยู่บนถนน เห็นทรงพุ่มของต้นไม้สีเขียวขจี โครงสร้างสายสลิงที่ยึดสะพานสีเหลืองทองอร่าม อีกทั้งใต้สะพานพระราม 8 ยังเป็นสวนสาธารณะสำหรับคนกรุงไว้พักผ่อนหย่อนใจ สิ่งพิเศษสุดของสะพานพระราม 8 ที่สะพานอื่นในกรุงเทพฯ ยังไม่มีก็คือ ที่ปลายยอดเสาสูงของตัวสะพานจะมีจุดชมทิวทัศน์ ซึ่งมีโครงสร้างโลหะกรุกระจกลักษณะคล้ายดอกบัว ดาวเทียมก็สามารถมองเห็นได้
          '
        />
      </Box>

      <Box id='r08'>
        <PlaceX id='r08' windowSize={[windowSize[0], windowHeight]} i0={map08_big} i2={map08_02000} i4={map08_04000} i8={map08_08000} di2={d_map08_02000} di4={d_map08_04000} di8={d_map08_08000} t2='คลองชักพระ' t1='Khlong Chak Phra' l={lang}
          t3='‘Khlong Chak Phra’ or ‘Khlong Bang Khun Si’ was once part of the Chao Phraya River. Khlong Chak Phra branches off from Khlong Bangkok Noi near Suwannakhiri Temple and connects to the area where Khlong Mon intersects with Khlong Bangkok Yai. The canal is approximately 10–15 metres wide and 5.45 kilometres long. Every year, on the 2nd day of the waning moon in the 12th lunar month, a traditional procession called ‘Chak Phra’ takes place. During this event, a boat bearing a Buddha statue is towed from Wat Nang Chi in Khlong Phasi Charoen through Khlong Chak Phra and Khlong Bangkok Noi out to the Chao Phraya River, then use Khlong Bangkok Yai to returns to Wat Nang Chi. This is the only Chak Phra festival in Bangkok and is the origin of the canal’s name. Nowadays, Khlong Chak Phra serves as a canal for drainage, transportation, and tourism, connecting with other canals such as Khlong Ban Sai, Khlong Bang Ramat, and Khlong Bang Phrom, and also acts as a boundary line along its entire length between Bang Phlat District and Taling Chan District. The satellite allows us to recognize the size of canals compared to the Chao Phraya River, and it also reveals changes on both sides of the canal.
          '
          t4='“คลองชักพระ” หรือ คลองบางขุนศรี เคยเป็นส่วนหนึ่งของแม่น้ำเจ้าพระยามาก่อน คลองชักพระไหลแยกจากคลองบางกอกน้อยบริเวณวัดสุวรรณคีรีไปเชื่อมกับบริเวณที่คลองมอญตัดกับคลองบางกอกใหญ่ ลำคลองกว้างประมาณ 10–15 เมตร และยาว 5.45 กิโลเมตร ทุก ๆ วันแรม 2 ค่ำ เดือน 12 จะมีประเพณีชักพระ โดยเรือที่ประดิษฐานพระพุทธรูปจะถูกชักลากจากวัดนางชี คลองภาษีเจริญผ่านคลองชักพระและคลองบางกอกน้อย ออกสู่แม่น้ำเจ้าพระยา แล้วอ้อมมาเข้าคลองบางกอกใหญ่กลับไปที่วัดนางชีตามเดิม ซึ่งนับเป็นงานประเพณีชักพระแห่งเดียวในกรุงเทพมหานคร และเป็นที่มาของชื่อคลองนี้ ปัจจุบัน คลองชักพระเป็นคลองเพื่อการระบายน้ำ การสัญจร และการท่องเที่ยว มีคลองอื่น ๆ ไหลเชื่อม ได้แก่ คลองบ้านไทร คลองบางระมาด และคลองบางพรม และยังเป็นแนวแบ่งเขตบางกอกน้อยกับเขตตลิ่งชันตลอดทั้งสายด้วย ดาวเทียมทำให้เห็นถึงขนาดของลำคลองเมื่อเทียบกับแม่น้ำเจ้าพระยา และเห็นถึงการเปลี่ยนแปลงของพื้นที่รอบริมคลอง
          '
        />
      </Box>

      <Box id='r06'>
        <PlaceX id='r06' windowSize={[windowSize[0], windowHeight]} i0={map06_big} i2={map06_02000} i4={map06_04000} i8={map06_08000} di2={d_map06_02000} di4={d_map06_04000} di8={d_map06_08000} t2='วัดอรุณราชวรารามราชวรมหาวิหาร' t1='Wat Arun Ratchawararam Ratchawaramahawihan' l={lang}
          t3='Wat Arun Ratchawararam Ratchawaramahawihan or Wat Arun (Temple of Dawn), formerly called ‘Wat Makok’, is one of the famous first class royal temples in Thailand. Wat Arun is the Buddhist temple of the Rattanakosin Kingdom situated on the west bank of the Chao Phraya River. Presently, it is a well-known site that attracts tourists around the world to visit this landmark. Through the satellite image, the white 82-meter-spire pagoda with 4 small pagodas can be clearly observed. Moreover, THEOS-2 satellite will serve as a tool for developing green spaces and enhancing Thailand’s tourism industry.
          '
          t4='“วัดอรุณราชวรารามราชวรมหาวิหาร” เป็นอีกหนึ่งวัดสำคัญของไทย เดิมมีชื่อว่า “วัดมะกอก” เป็นวัดคู่บ้านคู่เมืองพระอารามหลวงชั้นเอก เป็นศาสนสถานงานศิลป์ชั้นเอกแห่งกรุงรัตนโกสินทร์ ตั้งอยู่ติดริมน้ำเจ้าพระยาในเขตบางกอกใหญ่ ปัจจุบันกลายเป็นแหล่งท่องเที่ยวชั้นนำ ที่มีนักท่องเที่ยวทั้งชาวไทยและต่างชาติ มุมมองจากภาพดาวเทียมมีความสวยงามเป็นอย่างยิ่ง โดยมีพระปรางค์ประธานขนาดใหญ่สีขาวเป็นจุดเด่น มีความสูงจากฐานถึงยอด 81.85 เมตร และปรางค์ทิศจำนวน 4 ปรางค์ นอกจากนี้ ดาวเทียม THEOS-2 จะเป็นเครื่องมือที่ใช้ในการพัฒนาพื้นที่สีเขียวและพัฒนาการท่องเที่ยวของประเทศไทยได้
          '
        />
      </Box>

      <Box id='r07'>
        <PlaceX id='r07' windowSize={[windowSize[0], windowHeight]} i0={map07_big} i2={map07_02000} i4={map07_04000} i8={map07_08000} di2={d_map07_02000} di4={d_map07_04000} di8={d_map07_08000} t2='สถานีท่าพระ' t1='Tha Phra Station' l={lang}
          t3='‘Tha Phra Station’ is located at the Tha Phra intersection, which is a key crossing point between Phetkasem Road, Ratchadaphisek Road and Charan Sanitwong Road. Given its significance, the Mass Rapid Transit Authority of Thailand (MRTA) has selected Tha Phra as a major station on the Chalerm Ratchamongkol (Blue Line) of the Bangkok Mass Transit System, serving the public along the routes from Hua Lamphong to Tha Phra to Bang Khae, and from Bang Sue to Tha Phra. Both routes converge at Tha Phra intersection. Additionally, this station is elevated in the middle above the intersection extending in all directions, including Charan Sanitwong-Ratchadaphisek Road and towards Bang Khae on Phetkasem Road. THEOS-2 satellite reveals densely packed residences, buildings, constructions with green areas of vegetation intersection with transportation routes in form of plus signs or crosses. Therefore, satellite imagery becomes a suitable tool for enhancing transportation infrastructure.
          '
          t4='“สถานีท่าพระ” บริเวณสี่แยกท่าพระซึ่งเป็นจุดตัดผ่านระหว่างถนนเพชรเกษม, ถนนรัชดาภิเษก, ถนนจรัญสนิทวงศ์ ด้วยความสำคัญดังกล่าว การรถไฟฟ้าขนส่งมวลชนแห่ง- ประเทศไทย (รฟม.) จึงได้ปักหมุดให้ท่าพระเป็นสถานีสำคัญของรถไฟฟ้ามหานคร สายเฉลิมรัชมงคล สายสีน้ำเงิน เพื่อให้บริการสำหรับประชาชนในช่วงเส้นทางระหว่าง หัวลำโพง-ท่าพระ-บางแค และช่วง บางซื่อ-ท่าพระ โดยทั้งสองเส้นทางมีจุดบรรจบกันที่สี่แยกท่าพระ นอกจากนี้ สถานีดังกล่าวยังถูกใช้ เป็นสถานีร่วมบริเวณกลางสี่แยก ยกระดับทอดตัวไปทุกด้านถนน ได้แก่ แนวถนนจรัญสนิทวงศ์-รัชดาภิเษก, แนวถนนเพชรเกษมมุ่งหน้า บางแค มุมมองจากอวกาศซึ่งถ่ายภาพโดยดาวเทียม THEOS-2 เผยให้เห็นบ้านเรือน อาคาร และสิ่งปลูกสร้างที่หนาแน่น แทรกด้วยพื้นที่สีเขียวของพืชพรรณทั่วทั้งภาพ ผสานกับเส้นทางคมนาคมที่ซ้อนทับกันเป็นรูปเครื่องหมายบวกหรือกากบาท ภาพถ่ายดาวเทียมจึงเหมาะที่จะนำมาใช้เป็นเครื่องมือในการพัฒนาศักยภาพด้านการคมนาคม
          '
        />
      </Box>

      <Box id='r01'>
        <PlaceX id='r01' windowSize={[windowSize[0], windowHeight]} i0={map01_big} i2={map01_02000} i4={map01_04000} i8={map01_08000} di2={d_map01_02000} di4={d_map01_04000} di8={d_map01_08000} t2='ไอคอนสยาม' t1='ICONSIAM' l={lang}
          t3='"ICONSIAM" is a large shopping centre located on the bank of Chao Phraya River. From the space perspective, the beautifully balanced architecture of the building itself and a wide waterfront area, the  River Park, offering a relaxing atmosphere are shown. THEOS-2 captures imagery at  an altitude of 621 kilometres above ground, revealing the dense city in the Khlong San area, including the major waterway of the Chao Phraya River, bustling with both small and large boats.
          '
          t4='“ไอคอนสยาม” ศูนย์การค้าขนาดใหญ่ริมแม่น้ำเจ้าพระยา เมื่อมองด้วยดวงตาจากอวกาศจะเห็นถึงความสวยงามของสถาปัตยกรรมที่สวยงามอย่างลงตัวของทั้งตัวอาคารและลานหน้าห้างถูกออกแบบให้เป็น River Park คอมมูนิตี้สเปซลานกว้างริมน้ำที่บรรยากาศสุดผ่อนคลาย ภาพถ่ายจากดาวเทียม THEOS-2 ที่ระดับความสูง 621 กิโลเมตรเหนือพื้นโลก เมื่อขยายมาตราส่วนลงมาบริเวณพื้นที่เขตคลองสานจะเห็นความหนาแน่นของสิ่งก็สร้างต่างๆมากมายรวมถึงเส้นทางน้ำขนาดใหญ่นั่นก็คือ แม่น้ำเจ้าพระยาที่มีการสัญจรของเรือทั้งขนาดเล็กและขนาดใหญ่
          '
        />
      </Box>

      <Box id='r10'>
        <PlaceX id='r10' windowSize={[windowSize[0], windowHeight]} i0={map10_big} i2={map10_02000} i4={map10_04000} i8={map10_08000} di2={d_map10_02000} di4={d_map10_04000} di8={d_map10_08000} t2='วงเวียนใหญ่' t1='Wongwian Yai' l={lang}
          t3='"Wongwian Yai" is the location of the King Taksin the Great Monument. It is a multi-layered circle surrounded by densely packed residential and commercial buildings. Wongwian Yai serves as a junction connecting four main roads: 
          1. Pracha Thipok Road, which heads towards the Phra Nakhon side, with the Memorial Bridge serving as a connector to Mahachai Road, Chakrawat Road, leading to Pahurat and Yaowarat (China Town).
          2. Phetkasem Road, which leads towards the south of Bangkok and was also the main route to the south of Thailand, including access to Charan Sanitwong Road.
          3. Lat Ya Road, which connects to Charoen Nakhon Road and Somdet Chao Phraya Road.
          4. Somdet Phra Chao Taksin Road, which links to Suksawat Road, Dao Khanong, and Rama II Road.
          The satellite imagery allows us to perceive distinctive architecture, highlighting the urban layout from a high perspective. This is suitable for urban development, tourism, and planning to enhance the quality of life for the people.
          '
          t4='“วงเวียนใหญ่” เป็นที่ตั้งของพระบรมราชานุสาวรีย์สมเด็จพระเจ้าตากสินมหาราช เป็นวงกลมขยายออกมาหลายชั้น รายล้อมไปด้วยบ้านเรือนและอาคารพาณิชย์ที่หนาแน่น วงเวียนใหญ่เป็นจุดเชื่อมต่อถนน 4 สาย ได้แก่ 
          สายที่ 1 ถนนประชาธิปก มุ่งหน้าไปทางฝั่งพระนคร มีสะพานพุทธเป็นจุดเชื่อมต่อ เพื่อต่อไปยังถนนมหาไชย ถนนจักรวรรดิ์ ไปพาหุรัด เยาวราช , 
          สายที่ 2 ถนนเพชรเกษม มุ่งหน้าไปทางกรุงเทพฯ ฝั่งใต้ และในอดีตยังเป็นเส้นทางสายหลักที่วิ่งลงภาคใต้ของไทยด้วย รวมถึง ยังเป็นเส้นทางที่วิ่งไปทางถนนจรัญสนิทวงศ์ได้ด้วย , 
          สายที่ 3 ถนนลาดหญ้า เชื่อมต่อถนนเจริญนครและถนนสมเด็จเจ้าพระยา 
          และสายที่ 4 ถนนสมเด็จพระเจ้าตากสิน เชื่อมถนนสุขสวัสดิ์ ดาวคะนอง พระราม 2 ภาพจากดาวเทียมทำให้มองเห็นความโดดเด่นด้านสถาปัตยกรรมของผังเมืองจากมุมสูง เหมาะสำหรับการพัฒนาเมือง การท่องเที่ยว วางแผนการพัฒนาคุณภาพชีวิตของประชาชน
          '
        />
      </Box>


      <Container maxWidth="false" sx={{ backgroundColor: 'black', color: 'white' }}>
        <Grid container spacing={5} padding={5}>
          <Grid xs={12} sm={4} padding={5} spacing={1} container direction="column">
            <Grid spacing={1} item><Typography variant='h3'>GISTDA</Typography></Grid>
            <Grid spacing={1} item><Typography variant='body1'>สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน) สำนักงานใหญ่ (ศูนย์ราชการเฉลิมพระเกียรติ 80 พรรษา 5 ธันวาคม 2550)
              เลขที่ 120 อาคารรวมหน่วยราชการ (อาคารรัฐประศาสนภักดี) ชั้น 6 และชั้น 7 ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพฯ 10210</Typography>
            </Grid>
            <Box height={30} />
            <Grid spacing={1} item>
              <a href='https://www.gistda.or.th/' target='_blank'>
                <Link component="button" variant="h5" color={'#8BBFFF'}> เข้าสู่เว็บไซต์หลัก </Link>
              </a>
            </Grid>
          </Grid>

          <Grid xs={12} sm={4} padding={5} spacing={1} container direction="column">
            <Grid item>
              <Typography item variant='h3'>ติดต่อเรา</Typography>
            </Grid>
            <Grid item spacing={1} container direction="row">
              <Grid item><img width={40} src={mail} align='center' /></Grid>
              <Grid item><Typography item variant='body1'>info@gistda.or.th</Typography></Grid>
            </Grid>
            <Grid item spacing={1} container direction="row">
              <Grid item><img width={40} src={phone} align='center' /></Grid>
              <Grid item><Typography item variant='body1'>Call Center  :  0 2141 4444</Typography></Grid>
            </Grid>
            <Grid item spacing={1} container direction="row">
              <Grid item><img width={40} src={phone} align='center' /></Grid>
              <Grid item><Typography item variant='body1'>ข้อมูลผลิตภัณฑ์และบริการ <br /> 0 2141 1565  ,  0 2141 4593</Typography></Grid>
            </Grid>
          </Grid>

          <Grid xs={12} sm={4} padding={5} spacing={1} container direction="column">
            <Grid item>
              <Typography item variant='h3'>สื่อมีเดีย</Typography>
            </Grid>
            <Grid item spacing={1} container direction="row">
              <Grid item><img src={fb} width={30} align='center' /></Grid>
              <Grid item><a item variant='body1' href='https://www.facebook.com/gistda/' target='_blank'>
                <Link component="button" variant="body1" color={'#FFF'}> GISTDA </Link>
              </a></Grid>
            </Grid>
            <Grid item spacing={1} container direction="row">
              <Grid item><img src={yt} width={30} align='center' /></Grid>
              <Grid item><a item variant='body1' href='https://www.youtube.com/c/GISTDAspace' target='_blank'>
                <Link component="button" variant="body1" color={'#FFF'}> GISTDA </Link>
              </a></Grid>
            </Grid>
            <Grid item spacing={1} container direction="row">
              <Grid item><img src={lin} width={30} align='center' /></Grid>
              <Grid item><a item variant='body1' href='https://th.linkedin.com/company/gistda' target='_blank'>
                <Link component="button" variant="body1" color={'#FFF'}> GISTDA </Link>
              </a></Grid>
            </Grid>
            <Grid item spacing={1} container direction="row">
              <Grid item><img src={ig} width={30} align='center' /></Grid>
              <Grid item><a item variant='body1' href='https://www.instagram.com/gistda_space' target='_blank'>
                <Link component="button" variant="body1" color={'#FFF'}> GISTDA_SPACE </Link>
              </a></Grid>
            </Grid>
            <Grid item spacing={1} container direction="row">
              <Grid item><img src={tt} width={30} align='center' /></Grid>
              <Grid item><a item variant='body1' href='https://www.tiktok.com/@gistda_space' target='_blank'>
                <Link component="button" variant="body1" color={'#FFF'}> GISTDA_SPACE </Link>
              </a></Grid>
            </Grid>
            <Grid item spacing={1} container direction="row">
              <Grid item><img src={x} width={30} align='center' /></Grid>
              <Grid item><a item variant='body1' href='https://x.com/gistda' target='_blank'>
                <Link component="button" variant="body1" color={'#FFF'}> GISTDA_SPACE </Link>
              </a></Grid>
            </Grid>
            <Grid item spacing={1} container direction="row">
              <Grid item><img src={line} width={30} align='center' /></Grid>
              <Grid item><a item variant='body1' href='https://page.line.me/?accountId=gistda' target='_blank'>
                <Link component="button" variant="body1" color={'#FFF'}> @GISTDA </Link>
              </a></Grid>
            </Grid>

          </Grid>
        </Grid>

      </Container>


    </div >
  );
}

export default Home;
